import { Tooltip, Typography } from "antd";
import React from "react";

interface InputLabelProps {
  label: string;
  description?: string;
  required?: boolean;
}

const InputLabel: React.FC<InputLabelProps> = ({
  label,
  description,
  required,
}) => {
  return (
    <Typography.Text className="!my-1.5 flex items-center text-sm text-[#4E5158] font-medium min-h-[32px]">
      {label}
      {/* {required && <span className="text-red-600">&nbsp;*</span>} */}
      {/* {required && <span className="text-dark">&nbsp;*</span>} */}
      {description && (
        <Tooltip title={description}>
          <svg
            className="ml-2"
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.314 5.15596C10.3142 6.17596 10.0119 7.17311 9.44534 8.02131C8.8788 8.86951 8.07346 9.53065 7.13116 9.92112C6.18886 10.3116 5.15192 10.4139 4.1515 10.215C3.15107 10.0161 2.23209 9.52505 1.51077 8.80387C0.789449 8.08269 0.298194 7.1638 0.0991287 6.16341C-0.0999363 5.16302 0.00213096 4.12607 0.392423 3.1837C0.782714 2.24132 1.4437 1.43585 2.29179 0.869143C3.13987 0.302441 4.13696 -3.71741e-05 5.15696 -3.71933e-05C6.52411 0.00128612 7.83489 0.544899 8.8017 1.51152C9.76851 2.47814 10.3124 3.78882 10.314 5.15596V5.15596ZM9.28296 5.15596C9.28296 4.33992 9.04098 3.5422 8.58761 2.86368C8.13424 2.18516 7.48984 1.65632 6.73592 1.34404C5.98199 1.03175 5.15239 0.95004 4.35202 1.10924C3.55166 1.26845 2.81647 1.66141 2.23944 2.23844C1.66241 2.81547 1.26945 3.55065 1.11024 4.35102C0.951042 5.15139 1.03275 5.98099 1.34504 6.73491C1.65732 7.48884 2.18616 8.13324 2.86468 8.58661C3.5432 9.03998 4.34092 9.28196 5.15696 9.28196C6.25092 9.2809 7.29977 8.84586 8.07332 8.07232C8.84686 7.29877 9.28191 6.24992 9.28296 5.15596V5.15596ZM5.67297 3.35596V5.41296C5.67603 5.48257 5.66497 5.55208 5.64045 5.61729C5.61592 5.68251 5.57845 5.74208 5.53027 5.79242C5.4821 5.84276 5.42424 5.88282 5.36016 5.91019C5.29609 5.93756 5.22714 5.95167 5.15746 5.95167C5.08779 5.95167 5.01884 5.93756 4.95477 5.91019C4.89069 5.88282 4.83283 5.84276 4.78466 5.79242C4.73648 5.74208 4.69901 5.68251 4.67448 5.61729C4.64996 5.55208 4.6389 5.48257 4.64196 5.41296V3.35096C4.64781 3.21817 4.70468 3.09276 4.80072 3.00086C4.89675 2.90897 5.02455 2.85767 5.15746 2.85767C5.29038 2.85767 5.41818 2.90897 5.51421 3.00086C5.61025 3.09276 5.66711 3.21817 5.67297 3.35096V3.35596ZM5.67297 7.22296C5.67297 7.32502 5.6427 7.42478 5.586 7.50964C5.5293 7.59449 5.44872 7.66063 5.35443 7.69968C5.26014 7.73874 5.15639 7.74896 5.0563 7.72905C4.9562 7.70914 4.86426 7.65999 4.7921 7.58783C4.71993 7.51567 4.67079 7.42372 4.65088 7.32363C4.63097 7.22353 4.64119 7.11978 4.68024 7.0255C4.7193 6.93121 4.78543 6.85062 4.87029 6.79392C4.95515 6.73723 5.05491 6.70696 5.15696 6.70696C5.29321 6.7067 5.424 6.76043 5.52071 6.85639C5.61743 6.95235 5.67217 7.08272 5.67297 7.21896V7.22296Z"
              fill="black"
            />
          </svg>
        </Tooltip>
      )}
    </Typography.Text>
  );
};

InputLabel.defaultProps = {
  required: true,
};

export default InputLabel;
